export enum AdditionType {
  Package = "Package",
  Order = "Order",
}
